// extracted by mini-css-extract-plugin
export default {"inputContainer":"AnimationChat_inputContainer__sT2xG","querySectionText":"AnimationChat_querySectionText__9MbHf","querySectionText_2":"AnimationChat_querySectionText_2__xfN+8"};